<template>
    <div class="footer-links">
        <div class="footer-copy line-off">
            <div class="columns w-row">
                <div class="column-3 w-col w-col-5"><img src="images/DemandScale-Marketing-Logo.png" alt=""></div>
                <div class="w-clearfix w-col w-col-7">
                    <a href="faq.html" class="footer-copy-link hint">FAQ</a>
                    <a href="contact.html" class="footer-copy-link hint">Contact</a>
                    <a href="about.html" class="footer-copy-link hint">About</a>
                    <a href="index.html#socialproof" class="footer-copy-link hint">Social Proof</a>
                    <a href="index.html#scaleup" class="footer-copy-link hint">Why?</a></div>
            </div>
        </div>
        <div class="footer-copy">
            <div class="w-row">
                <div class="w-col w-col-5">
                    <div class="footer-copy-text hint">DemandScale is a trademark of Sift Media, Inc.</div>
                </div>
                <div class="w-clearfix w-col w-col-7">
                    <a href="https://www.sift.co/privacy-faq" target="_blank" class="footer-copy-link hint">Privacy FAQ</a>
                    <a href="https://www.sift.co/opt-out" target="_blank" class="footer-copy-link hint">Opt Out</a>
                    <a href="https://www.sift.co/privacy" target="_blank" class="footer-copy-link hint">Privacy Policy</a>
                    <a href="terms.html" target="_blank" class="footer-copy-link hint">Terms</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
    }
</script>

<style>
</style>
